import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { Button } from '@base/lib/Button';
import { ResultPopup } from '@pro/420CheckIn/ResultPopup';
import site from 'pro/config/site';
import { SharePopupM } from '@base/lib/share/SharePopupM';
import { useRouter } from 'next/router';
import { useCheckInContext } from 'mod/checkIn/useCheckInContext';
import { isPhone } from 'base/utils/client';
import { SharePopupPC } from '@base/lib/share/SharePopupPC';

export const CheckInResult: FC = () => {
    const {
        checkInResultVisible,
        cancelCheckInResult,
        data,
        shareCallback,
    } = useCheckInContext();

    const router = useRouter();
    const { t } = useTrans();

    const { shareBoom } = data;

    return (
        <ResultPopup
            open={checkInResultVisible}
            onCancel={cancelCheckInResult}
        >
            <div className={'g-points'}>+{shareBoom.points}</div>
            <div className={'g-line-1'}>{t('web_checkin_make_rate_boom', { rate: shareBoom.boomRate })}</div>
            <div className={'g-line-2'}>
                {t('web_checkin_modal_share_tip', {
                    prev: shareBoom.checkInPoints,
                    next: shareBoom.boomPoints
                })}
            </div>

            {isPhone ? (
                <SharePopupM
                    url={router.pathname}
                    title={site.brand}
                    onClickItem={() => shareCallback(true)}
                    needLogin={false}
                >
                    {({ open }) => (
                        <Button
                            type={'primary'}
                            block
                            onClick={() => {
                                cancelCheckInResult();
                                open();
                            }}
                        >
                            {t('web_checkin_get_num_points_now', { num: shareBoom.boomPoints })}
                        </Button>
                    )}
                </SharePopupM>
            ):(
                <SharePopupPC
                    url={router.pathname}
                    onClickItem={() => {
                        cancelCheckInResult();
                        shareCallback(true)
                    }}
                >
                    <Button
                        type={'primary'}
                        block
                    >
                        {t('web_checkin_get_num_points_now', { num: shareBoom.boomPoints })}
                    </Button>
                </SharePopupPC>
            )}

        </ResultPopup>
    )
};
